import * as React from 'react'
import { cn } from '@/lib/utils'

// forwardRef for React 18 — voxi renders this inside Radix `asChild` slots.
const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  function Input({ className, type, ...props }, ref) {
  return (
    <input
      ref={ref}
      type={type}
      data-slot='input'
      className={cn(
        // jobsvox warm-paper field: white bg, hairline control border, 10px radius
        'flex h-9 w-full min-w-0 rounded-lg border border-input bg-card px-3 py-1 text-base shadow-none transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30',
        // ink focus ring, soft warm halo
        'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/15',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
        className
      )}
      {...props}
    />
  )
})

export { Input }
